import React from 'react'
import PropTypes from 'prop-types'
import Button from '../Button/Button'
import Flex from '../Flex/Flex'
import Text from '../Text/Text'

const AssignMessage = ({ amount, handleApply, handleCancel }) => (
  <>
    <Text size="xs" color="gray" margin="10px 0px">
      Você selecionou {amount} {amount > 1 ? 'lojas' : 'loja'}, deseja continuar
      ?
    </Text>
    <Flex column alignItems="center" justifyContent="center">
      <Button
        id="as_btn_continue"
        type="secondary"
        onClick={handleApply}
        margin="10px 0px"
      >
        <Text size="xxs" color="white">
          Continuar
        </Text>
      </Button>
      <Button id="as_btn_cancel" onClick={handleCancel}>
        <Text size="xxs" color="gray">
          Cancelar
        </Text>
      </Button>
    </Flex>
  </>
)

AssignMessage.defaultProps = {
  amount: 0
}

AssignMessage.propTypes = {
  amount: PropTypes.number,
  handleApply: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired
}

export default React.memo(AssignMessage)
